import ApiService from '@/services/core/api.service'

const DurationService = {
  async get (query) {
    return ApiService.get(`admin/durations?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/durations', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/durations/${payload.id}`, payload)
  }
}

export default DurationService
